export default __webpack_public_path__ + "locales/bg/PaymentsEnterprise.json?hash=a04689b79c16ef4c18b6887b18a4f694";